import React from 'react';
import Immutable from 'immutable';
import {
	styled,
	ParentBoundComponent,
	Module,
	Button,
	Icon,
	RuntimeUtils,
	DateUtils,
} from 'ps-gui';

import {
	getFormItemLabel,
	getPhrase,
	getPhraseOrNull
} from '../../data/phrases';
import IsrcProtocolModel from './isrcprotocolmodel';
import {
	ModuleBodySection,
	ModuleHeaderSection,
	ModuleHeader,
	ModuleHeaderBlock,
	ModuleHeaderSubtext
} from '../../blocks/modulesections';
import { ReactComponent as ModuleLogo } from '../../svg/submission.svg';
import {
	getGlobalContextChangeChecker
} from '../utils';
import {
	Dialog,
	DialogButtons,
	DialogContent,
	DialogHeader,
} from '../../components/dialog';
import { withGlobalContext } from '../../data/globalcontext';


const Wrapper = styled.div`
`;

const Content = styled.div`
	margin-top: 24px;
`;

const FormWrapper = styled.div`
	max-width: 700px;
	.ps-formItem {
		margin-bottom: 24px;
	}
`;

const RowCountEtc = styled.div`
	margin-bottom: 24px;
`;

const RowCount = styled.div`
	display: inline-block;
	color: ${props => props.theme.disabledTextColor};
	font-size: 20px;
	margin-right: 40px;
	.label {
		font-weight: 400;
		margin-right: 5px;
	}
	.value {
		font-weight: 900;
	}
`;

const TabText = styled.span`

	.icon {
		position: relative;
		top: -1px;
	}

	.icon.left {
		margin-right: 8px;
	}

	.icon[data-name=close] {
		margin-left: 16px;
		* {
			fill: #4FC098;
		}
	}
`;

const QuickFilterHeader = styled.div`
	font-size: 14px;
	font-weight: 500;
	color: ${props => props.theme.disabledTextColor};
	margin-bottom: 8px;
`;

const QuickFilter = styled.div`
	margin-bottom: 24px;
	.checkButton {
		margin-right: 16px;
	}
`;

const DialogIsrcProtocol = styled.div`
	position: relative;
	.createdWhen {
		color: #575757CC;
		position: absolute;
		right: 0px;
		top: 0px;
		font-weight: 300;
		font-size: 14px;
		line-height: 30px;
	}

	.type {
		padding-right: 80px;
		font-weight: 400;
		font-size: 16px;
		line-height: 24px;
	}

	.name {
		font-weight: 500;
		font-size: 16px;
		line-height: 30px;
		color: #575757;
		margin-right: 16px;
		display: inline-block;
	}
`;

const EMPTY_MAP = Immutable.Map({});
const EMPTY_LIST = Immutable.List([]);


const recAttrs = [
	'isrc',
	'title',
	'subtitle',
	'producer',
	'label',
	'recordingTypeId',
	'genreId',
	'productionYear',
	'releaseYear',
	'studio',
	'masterNumber',
	'albumCatalogNumber',
	'trackNumber',
	'length',
	'language',
	'recordingRegistrationDate',
	'recordingCountryId',
	'album',
	'mainArtist',
];

const RecordingAttribute = styled.div`
	padding: 2px 8px;
	white-space: nowrap;

	.label {
		display: inline-block;
		min-width: 220px;
		padding-right: 8px;
		color: ${props => props.theme.disabledTextColor};
	}

	.value {
		display: inline-block;
		font-weight: 500;
		padding-right: 8px;
		min-width: 220px;
		white-space: normal;
		max-width: calc( 100vw - 440px );
	}

	.subvalue {
		display: inline-block;
		font-size: 90%;
		margin-left: 8px;
	}

	cursor: default;
	&:hover {
		background: ${props => props.theme.tableRowSelectedBackground};
	}
`;

const SubHeader = styled.div`
	text-align: center;
	margin: 8px 0px;
	font-weight: 500;
	color: ${props => props.theme.disabledTextColor};
`;

class IsrcProtocolModule extends ParentBoundComponent {

	constructor() {
		super();

		this.customResultProps = Object.assign({}, customResultProps);
		this.checkGlobalContextChange = getGlobalContextChangeChecker(this);
		this.onRowAction = this.onRowAction.bind(this);
		this.openDetail = this.openDetail.bind(this);
		this.customResultProps.toolBar =
			<Icon
				name="refresh"
				active
				hint={getPhrase('refresh')}
				onMouseDown={async () => {
					this.setModel(await this.getModel().refreshSearch(true));
				}}
			/>;
	}

	async openDetail(isrc) {
		this.setModel(await this.getModel().openDetail(isrc));
	}

	async onRowAction(row, rowIndex, options) {
		const isrc = row.get('isrc');
		this.openDetail(isrc);
	}


	getModel() {
		return new IsrcProtocolModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	async componentDidMount() {
		/*if (!this.getData().get('initialized')) {
			this.setModel(await this.getModel().initialize());
		}*/
		this.checkGlobalContextChange();
	}

	componentDidUpdate(prevProps) {
		this.checkGlobalContextChange(prevProps);
	}


	/*
					<RowCountEtc>
						<RowCount>
							<span className="label">{getPhrase('recordingCount')}:</span>
							<span className="value">{(data.getIn([
								'search',
								'data',
								'result',
								'data',
								'pager',
								'totalCount'
							]))}</span>
						</RowCount>
					</RowCountEtc>

	*/
	renderList() {
		const data = this.getData();
		return (
			<Content>
				<Module
					appState={data.get('search')}
					onDataChange={newData => {
						this.setData(data.setIn(['search', 'data'], newData));
					}}
					customResultProps={this.customResultProps}
					onRowAction={this.onRowAction}
				//leftToolBar={this.renderCandidateListToolbar}
				//onResultIconMouseDown={this.onCandidateIconMouseDown}
				/>
			</Content>
		);
	}

	renderDetail() {
		const data = this.getData();
		const detail = data.get('detail');

		return (
			<Dialog
				onCloseRequested={() => {
					this.setModel(this.getModel().hideDetail());
				}}
			>
				<DialogHeader marginBottom="16px">{getPhrase('recordingDetail')}</DialogHeader>
				<DialogContent maxHeight="calc( 100vh - 200px )" overflow="auto">
					{
						recAttrs.map((attr, index) => {
							let value = detail.get(attr);
							if (!value) {
								return null;
							}
							if (attr === 'length') {
								value = RuntimeUtils.formatRuntime(value);
							} else if (attr === 'genreId') {
								value = getPhrase('genre.' + value);
							} else if (attr === 'recordingTypeId') {
								value = getPhrase('recordingType' + value);
							} else if (attr === 'recordingRegistrationDate') {
								value = DateUtils.formatDate(value);
							}
							return (
								<RecordingAttribute key={index}>
									<span className='label'>{getFormItemLabel(attr, 'isrcProtocol')}:</span>
									<span className='value'>
										{value}
									</span>
								</RecordingAttribute>
							);
						})
					}
					<SubHeader>{getFormItemLabel('performers')}</SubHeader>
					{
						(detail.get('lineup') || EMPTY_LIST).map((perf, index) => {
							if (perf.get('creatorCategoryId') !== 'PER') {
								return null;
							}
							let role = perf.get('creatorRoleId');
							if (role) {
								role = getPhraseOrNull('creatorRole.PER.POP.' + role) || getPhraseOrNull('creatorRole.PER.CLS.' + role);
							}

							return (
								<RecordingAttribute key={index}>
									<span className='value'>{perf.get('name')}</span>
									<span className='subvalue'>{role}</span>
								</RecordingAttribute>
							);
						})
					}
				</DialogContent>
				<DialogButtons>
					<Button
						text={getPhrase('close')}
						type="medium"
						onAction={() => {
							this.setModel(this.getModel().hideDetail());
						}}
					/>
				</DialogButtons>
			</Dialog>
		);
	}

	render() {
		const data = this.getData();
		const detail = data.get('detail');
		const langId = data.get('langId');
		return (
			<Wrapper>
				<ModuleHeaderSection className="noBorder" padding="16px 0px">
					<ModuleHeaderBlock>
						<ModuleHeader>{getPhrase('IsrcProtocol')}</ModuleHeader>
						<ModuleHeaderSubtext>
							{
								langId === 'EN' ? (
									<>This database contains only recordings that have been registered with Intergram on the basis of correctly completed <a target="_blank" href="https://www.intergram.cz/en/registration-of-recordings#recording-protocol">Recording Protocols</a>. It is therefore not a complete database of released recordings.</>
								) : (
									<>Tato databáze obsahuje pouze nahrávky, které byly u Intergramu zaregistrovány na základě správně vyplněných <a target="_blank" href="https://www.intergram.cz/registrace-nahravek#nahravaci-protokol">Nahrávacích protokolů</a>. Nejedná se tak o kompletní databázi vydaných nahrávek.</>
								)
							}
						</ModuleHeaderSubtext>
					</ModuleHeaderBlock>
					<ModuleHeaderBlock>
						<ModuleLogo />
					</ModuleHeaderBlock>
				</ModuleHeaderSection>
				<ModuleBodySection top="-60px">
					{this.renderList()}
				</ModuleBodySection>
				{
					!!detail && this.renderDetail()
				}
			</Wrapper>
		);
	}
}

const cellRendererMap = Object.freeze({
	'length': (cell, row) => {
		return RuntimeUtils.formatRuntime(cell);
	},
});

const customResultProps = {
	cellRendererMap,
	rowCountLabel: () => getPhrase('rowCount'),
	defaultColumnWidths: {
		isrc: '180px',
		length: '120px',
		album: '200px'
	},
	columnAlign: {
		length: 'right'
	},
	columnFilters: {
		'length': {
			type: 'runtime'
		},
		isrc: {
			type: 'text'
		},
		title: {
			type: 'text'
		},
		album: {
			type: 'text'
		},
		performers: {
			type: 'text'
		},
	}
};

export default withGlobalContext(IsrcProtocolModule);
